import React from 'react';
import PropTypes from 'prop-types';

import { interpolateString } from 'ctm-util-functions';
import { getRuleRangeValues } from '../utils';
import styles from './validation_indicator.css';

/**
 * ValidationIndicator React Component
 * @desc This is simple component that wraps the Text Component allowing modify its contentProps and set its visualProps.
 *       It is set by the FormElementFactory and is usually used to show help text messages next to the field.
 * @param {Object} props React props
 * @returns {Node} A ValidationIndicator component
 */
const ValidationIndicator = (props) => {
    /**
     * If contentProps.label contains markup that can be interpolated, get the relevant rule and substitute the values.
     * Otherwise just return contentProps.label
     * @returns {String} - The content for the validation indicator
     */
    const getContent = () => {
        const content = props.contentProps.label;
        if (content.match(/{([^{}]*)}/g) === null) {
            return content;
        }

        const rangeValues = getRuleRangeValues(props.rules.validation, props.contentProps.mask);
        const messageState = Object.assign(rangeValues, props.selectedValues);

        return interpolateString(content)(messageState);
    };

    return (
        <span className={styles.validation_indicator}>{getContent()}</span>
    );
};

ValidationIndicator.propTypes = {
    /**
     * Content properties similar to ones used by the Text Component
     */
    contentProps: PropTypes.shape({
        /**
         * A text label. If provided, it will not use stateKey or innerHTML.
         */
        label: PropTypes.string,
        /**
         * HTML string -- parses and returns sanitized HTML and injects with dangerouslySetInnerHTML
         */
        innerHTML: PropTypes.string,
        mask: PropTypes.string
    }),
    rules: PropTypes.object,
    selectedValues: PropTypes.object
};

export { ValidationIndicator };
